import AudioRecording from '~components/AudioRecording'

const CacheableAudioRecording = AudioRecording

export { CacheableAudioRecording }
